import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const ChallengeLeaderboard = ({ challenge, onClose }) => {
  const { authFetch } = useAuth();
  const [leaderboard, setLeaderboard] = useState([]);
  const [myRank, setMyRank] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadLeaderboard = useCallback(async () => {
    try {
      const res = await authFetch(`/api/challenges/${challenge.id}/leaderboard?limit=20`);
      if (res.ok) {
        const data = await res.json();
        setLeaderboard(data.leaderboard || []);
        setMyRank(data.my_rank);
      }
    } catch (err) {
      console.error('Failed to load leaderboard:', err);
    } finally {
      setLoading(false);
    }
  }, [authFetch, challenge.id]);

  useEffect(() => {
    loadLeaderboard();
  }, [loadLeaderboard]);

  const getRankBadge = (rank) => {
    if (rank === 1) return '🥇';
    if (rank === 2) return '🥈';
    if (rank === 3) return '🥉';
    return rank;
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content leaderboard-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Leaderboard</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="leaderboard-challenge">
          <h3>{challenge.title}</h3>
          <p>Target: {challenge.target_value} {challenge.target_unit}</p>
        </div>

        {loading ? (
          <div className="leaderboard-loading">Loading...</div>
        ) : leaderboard.length === 0 ? (
          <div className="leaderboard-empty">No participants yet</div>
        ) : (
          <div className="leaderboard-list">
            {leaderboard.map((entry, idx) => (
              <div
                key={entry.user_id}
                className={`leaderboard-item ${entry.completed ? 'completed' : ''}`}
              >
                <span className="leaderboard-rank">{getRankBadge(idx + 1)}</span>
                <div className="leaderboard-user">
                  <span className="leaderboard-name">{entry.name || entry.email}</span>
                  <div className="leaderboard-progress-bar">
                    <div
                      className="leaderboard-progress-fill"
                      style={{ width: `${Math.min(entry.progress_percent, 100)}%` }}
                    />
                  </div>
                </div>
                <div className="leaderboard-stats">
                  <span className="leaderboard-value">
                    {Math.round(entry.progress * 10) / 10}
                  </span>
                  <span className="leaderboard-percent">
                    {Math.round(entry.progress_percent)}%
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}

        {myRank && (
          <div className="leaderboard-my-rank">
            Your rank: #{myRank}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChallengeLeaderboard;
